import { render, staticRenderFns } from "./main-video.vue?vue&type=template&id=bb101b0a&scoped=true&"
import script from "./main-video.vue?vue&type=script&lang=js&"
export * from "./main-video.vue?vue&type=script&lang=js&"
import style0 from "./main-video.vue?vue&type=style&index=0&id=bb101b0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb101b0a",
  null
  
)

export default component.exports